import axios from "axios";
import { apiUrl } from '../../constants/config';
import { getCurrentUser } from "../../utils/auth";


export default {    
  state: {
    clients: [],
    ClientToEdit:null,
    usersList:[],
    RolesCurrentUser:null,
    CurrentUser:[]
  },
  getters: {
    getClients: (state) => {
      return state.clients;
    },
    getClientToEdit: (state) => {
      return state.ClientToEdit;
    },
    usersList: state => state.usersList,
    RolesCurrentUser: state => state.RolesCurrentUser,
    CurrentUser: state => state.CurrentUser
  },
  mutations: {
    DO_NOTHING() {},
    ADD_CLIENT(state, payload) {
      state.clients = payload;
    },
    ADD_CLIENT_TO_UPDATE(state,payload){
      state.ClientToEdit = payload
    },
    getUsersList(state, payload) {
      state.usersList = payload.usersList
    },
    getRolesCurrentUser(state, payload) {
      state.RolesCurrentUser = payload.RolesCurrentUser
    },
    getCurrentUser(state, payload){
      state.CurrentUser = payload.CurrentUser
    }
  },
  actions: {
    signupUser({commit, state}, {data,index}){
       return axios
          .post(
                apiUrl+"/api/auth/signup", data,{
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: 'Bearer ' + localStorage.getItem('authToken')
                  }
                }
          ).then(res => {
            state.usersList.splice(index, 1)
          }).catch(err => {
            console.log(err)
          })
    },

    getUsers({commit, state}){
      state.usersList = []
      return axios
        .get(
          apiUrl+"/api/auth/users",{
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Authorization: 'Bearer ' + localStorage.getItem('authToken')
            }
          })
        .then(response => {
            let data = response.data.users 

            Object.keys(data).forEach(key => {
              state.usersList.push(data[key])
            })

            console.log(state.usersList)
        })
        .catch(err => {
          console.log(err)
        })
    },
    removeUser({state, commit},{id}) {
      return axios
                .delete(apiUrl+"/api/auth/users/"+id,{
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: 'Bearer ' + localStorage.getItem('authToken')
                  }
                }).then(res => {

                }).catch(err => {
                  console.log(err)
                })
    },

    updateUser({state, commit}, {id, data}) {   
      return axios.put(
                        apiUrl+"/api/auth/users/"+id, data, 
                        {
                          headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            Authorization: 'Bearer ' + localStorage.getItem('authToken')
                          }
                        }
                  ).then (res => {
                    
                  }).catch( err => {
                    console.log(err)
                  })
    },
    
    getAllClient({ commit }) {
        axios
          .get(
            "https://testt-d63b1.firebaseio.com/client.json" 
          )
          .then((response) => {
            const data = response.data;
            const clients = [];
            for (let key in data) {
                const client = data[key];
                client.id = key;
                clients.push(client);
              
            }
            commit("ADD_CLIENT", clients);
          });
      },
    getClient({ commit },payload){
      axios
          .get(
            "https://testt-d63b1.firebaseio.com/client.json/"+payload
          )
          .then((response) => {
            const data = response.data;
            const client = data;
            commit("ADD_CLIENT_TO_UPDATE", client);
          });
    },
    async addClient({ commit }, payload) {
        try {
          const responce = await axios.post(
            "https://testt-d63b1.firebaseio.com/client.json" ,
            payload
          );
          commit("DO_NOTHING");
          return responce;
          
        } catch (error) {
          return null;
        }
      },
 
  async removeClient( { commit },payload) {
    try {
      const responce = await axios.delete(
        "https://testt-d63b1.firebaseio.com/client" +
          payload.id 
      );
      commit("DO_NOTHING");
      //commit("REMOVE_ARTICLE", payload);
      return responce
    } catch (error) {
      return null;
    }
  },
  getClients({commit, state}, payload){
      axios
        .get(
          "https://immo-wiin.com/api/users" 
        )
        .then((response) => {
          const data = response.data;
          console.log(response)
          // const clients = [];
          // for (let key in data) {
          //     const client = data[key];
          //     client.id = key;
          //     clients.push(client);
            
          // }
          // commit("ADD_CLIENT", clients);
        })
        .catch(error => {
          console.log(error)
        });
  },


  whoami({commit, state}) {
    state.CurrentUser = [];
    return axios.get(apiUrl+'/api/auth/user', { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'Bearer ' + localStorage.getItem("authToken") } }
    ).then((response) => {
        state.CurrentUser.push(response.data)
        state.RolesCurrentUser = (response.data.role == 1) ? "User" : "Admin"
    })
    .catch((e) => {
    })
  },




},
};
